// Схема пути: /:section/:view/r/:rowId. В адресе кодируется всё состояние экрана
// (правило 4): ссылку на строку коллега открывает в том же месте, что и отправитель.
// Чистые функции без React — их гоняют тесты и переиспользует что угодно.

export interface RoutePath {
  section: string;
  view: string;
  /** Выбранная строка списка. Сегмент /r/ отделяет её от имени представления. */
  rowId?: string;
}

export function buildPath(path: RoutePath): string {
  const base = `/${encodeURIComponent(path.section)}/${encodeURIComponent(path.view)}`;
  return path.rowId === undefined ? base : `${base}/r/${encodeURIComponent(path.rowId)}`;
}

/** Разбирает pathname. Не наша форма пути — null, решать, что показать, будет маршрутизатор. */
export function parsePath(pathname: string): RoutePath | null {
  const parts = pathname.split('/').filter((part) => part !== '');
  const [section, view, marker, rowId] = parts;
  if (section === undefined || view === undefined) {
    return null;
  }
  if (parts.length === 2) {
    return { section: decodeURIComponent(section), view: decodeURIComponent(view) };
  }
  if (parts.length === 4 && marker === 'r' && rowId !== undefined) {
    return {
      section: decodeURIComponent(section),
      view: decodeURIComponent(view),
      rowId: decodeURIComponent(rowId),
    };
  }
  return null;
}
